"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLoginFormGateway = exports.getGateway = void 0;
var _config = _interopRequireDefault(require("../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getGateway = exports.getGateway = function getGateway() {
  var configGateway = _config["default"].global.gateway;
  var currentGateway = localStorage.getItem('tradingServer');
  if (Array.isArray(configGateway)) {
    if (currentGateway && configGateway.includes(currentGateway)) {
      return currentGateway;
    } else {
      /**
       * This means the current gateway was entered via custom box.
       */
      return localStorage.getItem('tradingServer');
    }
  } else {
    if (configGateway && currentGateway !== configGateway) {
      localStorage.setItem('tradingServer', configGateway);
      return configGateway;
    } else {
      return currentGateway;
    }
  }
};
var getLoginFormGateway = exports.getLoginFormGateway = function getLoginFormGateway() {
  return _config["default"].global.gateway;
};